import { render, staticRenderFns } from "./PageAvatarDisplay.vue?vue&type=template&id=5f274e38&scoped=true"
import script from "./PageAvatarDisplay.vue?vue&type=script&lang=js"
export * from "./PageAvatarDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f274e38",
  null
  
)

export default component.exports